import { Observable } from 'rxjs';

import { finalize, tap } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { inject, Injectable, Injector } from '@angular/core';
import { ErrorService } from '../services/error.service';
import { LoadingIndicatorService } from '../services/loading-indicator.service';

@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector);
  loadingIndicatorService = this.injector.get(LoadingIndicatorService);

  constructor() {}

  handleError(response: any) {
    const errorService = this.injector.get(ErrorService);
    errorService.responseError(response);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //Die einzige Stelle, die den Indicator auf true setzt
    this.loadingIndicatorService.isLoading.set(true);

    return next.handle(req).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          {
            if (event instanceof HttpResponse) {
              if (event.status !== 200 || event.body.success === false) {
                this.loadingIndicatorService.isLoading.set(false);
                this.handleError(event);
              }
            }
          }
        },
        error: (err: any) => {
          this.loadingIndicatorService.isLoading.set(false);
          this.handleError(err);
        },
        complete: () => {
          this.loadingIndicatorService.isLoading.set(false);
        },
      }),
      finalize(() => {
        this.loadingIndicatorService.isLoading.set(false);
      })
    );
  }
}
